import { Route } from '@angular/router';
import { NetworkAllocationComponent } from 'src/app/pages/network/network-allocation/network-allocation.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const networkAllocation: Route = {
  path: 'network-allocation',
  data: {
    breadcrumb: 'nav.network.networkAllocation',
    title: 'nav.network.networkAllocation',
    icon: SbIcons.bookings,
    id: RoutingID.networkAllocation,
  },
  children: [
    {
      path: '',
      component: NetworkAllocationComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
